/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Embed_JobsInputs */

const en_usage_embed_jobs = /** @type {(inputs: Usage_Embed_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed Jobs`)
};

const fr_usage_embed_jobs = /** @type {(inputs: Usage_Embed_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Emplois intégrés`)
};

const de_usage_embed_jobs = /** @type {(inputs: Usage_Embed_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jobs einbetten`)
};

const it_usage_embed_jobs = /** @type {(inputs: Usage_Embed_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora lavori`)
};

const ru_usage_embed_jobs = /** @type {(inputs: Usage_Embed_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встраивание заданий`)
};

const es_usage_embed_jobs = /** @type {(inputs: Usage_Embed_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trabajos para incrustar`)
};

const zh_cn2_usage_embed_jobs = /** @type {(inputs: Usage_Embed_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`嵌入式工作`)
};

const ja_usage_embed_jobs = /** @type {(inputs: Usage_Embed_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`求人情報を埋め込む`)
};

const hi_usage_embed_jobs = /** @type {(inputs: Usage_Embed_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`एम्बेड जॉब्स`)
};

const pt_pt2_usage_embed_jobs = /** @type {(inputs: Usage_Embed_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empregos incorporados`)
};

/**
* | output |
* | --- |
* | "Embed Jobs" |
*
* @param {Usage_Embed_JobsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const usage_embed_jobs = /** @type {((inputs?: Usage_Embed_JobsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Embed_JobsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_usage_embed_jobs(inputs)
	if (locale === "de") return de_usage_embed_jobs(inputs)
	if (locale === "it") return it_usage_embed_jobs(inputs)
	if (locale === "ru") return ru_usage_embed_jobs(inputs)
	if (locale === "es") return es_usage_embed_jobs(inputs)
	if (locale === "zh-CN") return zh_cn2_usage_embed_jobs(inputs)
	if (locale === "ja") return ja_usage_embed_jobs(inputs)
	if (locale === "hi") return hi_usage_embed_jobs(inputs)
	if (locale === "pt-PT") return pt_pt2_usage_embed_jobs(inputs)
	return en_usage_embed_jobs(inputs)
});